/**
 * ═══════════════════════════════════════════════════════════════════════════
 *  PALETTE — Blue Primary + Orange Sales (Supermarket UI)
 *  Full production-safe token set
 * ═══════════════════════════════════════════════════════════════════════════
 */

const palette = {
  /* =========================
   * PRIMARY — BLUE (SYSTEM)
   * ========================= */
  primary: "#1D4ED8",
  primaryHover: "#1E40AF",
  primaryDark: "#1E3A8A",
  primaryLight: "#DBEAFE",
  primarySoft: "#EFF6FF",
  primaryBorder: "#93C5FD",

  /* =========================
   * BRAND — ORANGE (SALES / ACTIONS)
   * ========================= */
  brand: "#F97316",
  brandHover: "#EA580C",
  brandDark: "#C2410C",
  brandLight: "#FFF7ED",
  brandSoft: "#FFF5F5",
  brandBorder: "#FDBA74",

  /* =========================
   * SUPPORT — TEAL (INFO / FILTERS)
   * ========================= */
  support: "#14B8A6",
  supportHover: "#0D9488",
  supportSoft: "#CCFBF1",
  supportText: "#0F766E",

  /* =========================
   * SUCCESS / WARNING / DANGER
   * ========================= */
  success: "#22C55E",
  successSoft: "#DCFCE7",

  warning: "#F59E0B",
  warningSoft: "#FFFBEB",

  danger: "#EF4444",
  dangerSoft: "#FEF2F2",

  /* =========================
   * BASE — TEXT SYSTEM (BLUE-BASED)
   * ========================= */
  ink: "#1E2A5A",
  inkSoft: "#243B7A",
  inkMuted: "#3651A3",
  inkMid: "#4B6FE0",
  inkFaint: "#7FA2FF",
  inkCanvas: "#F8FAFC",
  inkOnDark: "#D6E4FF",

  /* =========================
   * SURFACES / BORDERS
   * ========================= */
  white: "#FFFFFF",
  surface: "#F1F5F9",
  surfaceAlt: "#F8FAFC",
  surfaceMuted: "#F9FAFB",

  line: "#E2E8F0",
  lineSoft: "#F1F5F9",
  lineStrong: "#CBD5E1",
  lineFaint: "#E5E7EB",

  /* =========================
   * SEMANTIC UI COLORS
   * ========================= */
  price: "#0F172A",
  discount: "#F97316",
  link: "#1D4ED8",
  info: "#1D4ED8",

  /* =========================
   * UI STATES
   * ========================= */
  hover: "#F8FAFC",
  active: "#E2E8F0",
  disabled: "#CBD5E1",

  /* =========================
   * DARK MODE
   * ========================= */
  night: "#0B1220",
  darkSurface: "#111827",
  darkSoft: "#1F2937",
  darkText: "#F8FAFC",

  /* =========================
   * MISC / SAFETY TOKENS
   * ========================= */
  editorRed: "#F97316",
  statusLate: "#FEF3C7",
};

module.exports = { palette };
